import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function SPBView(props) {
  const {
    fieldsValidation = {},
    procedure,
    applicantType,
    currentApplication = {},
  } = props;

  const applicant_new = currentApplication?.applicant_new || {};
  const registry_subject = currentApplication?.registry_subject || {};
  const files = currentApplication?.files || [];

  const {
    office_name,
    office_address,
    office_phone,
    office_email,
  } = applicant_new;

  const {
    office_name: old_office_name,
    office_address: old_office_address,
    office_phone: old_office_phone,
    office_email: old_office_email,
  } = registry_subject;

  const office_name_change_document = files.find(item => item.collection_name === 'office_name_change_document');
  const old_office_name_change_document = files.find(item => item.collection_name === 'old_office_name_change_document');

  const hasOfficeNameData = !!office_name || office_name === null;
  const hasOfficeLegalAddressData = !!office_address || office_address === null;
  const hasOfficeLocationAddressData = !!office_address || office_address === null;
  const hasOfficePhoneData = !!office_phone || office_phone === null;
  const hasOfficeEmailData = !!office_email || office_email === null;

  if (![PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) || applicantType !== USER_TYPE.LEGAL) {
    return null;
  }

  return (
    <>
      <div className="f4 mt-3">Изменились сведения о филиале (представительстве) в Санкт-Петербурге</div>

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasOfficeNameData,
            }}
            label="Изменилось наименование филиала"
          />
        </Col>
      </Row>
      {hasOfficeNameData && (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'old.office_name',
            old_office_name,
            fieldsValidation,
            'registry_subject.office_name',
          )}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'new.office_name',
            office_name,
            fieldsValidation,
            'applicant_new.office_name',
          )}
        </Row>
      </>
      )}
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasOfficeLegalAddressData,
            }}
            label="Изменился юридический адрес филиала"
          />
        </Col>
      </Row>
      {hasOfficeLegalAddressData && (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'old.sp.legal_address',
            old_office_address,
            fieldsValidation,
            'registry_subject.office_address',
          )}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'new.sp.legal_address',
            office_address,
            fieldsValidation,
            'applicant_new.office_address',
          )}
        </Row>
      </>
      )}
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasOfficeLocationAddressData,
            }}
            label="Изменился адрес местонахождения"
          />
        </Col>
      </Row>
      {hasOfficeLocationAddressData && (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'old.sp.office_location_address',
            old_office_address,
            fieldsValidation,
            'registry_subject.office_address',
          )}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'new.sp.office_location_address',
            office_address,
            fieldsValidation,
            'applicant_new.office_address',
          )}
        </Row>
      </>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasOfficePhoneData,
            }}
            label="Изменился телефонный номер"
          />
        </Col>
      </Row>
      {hasOfficePhoneData && (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'old.office_phone',
            old_office_phone,
            fieldsValidation,
            'registry_subject.office_phone',
          )}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'new.office_phone',
            office_phone,
            fieldsValidation,
            'applicant_new.office_phone',
          )}
        </Row>
      </>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasOfficeEmailData,
            }}
            label="Изменилась электронная почта"
          />
        </Col>
      </Row>

      {hasOfficeEmailData && (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'old.office_email',
            old_office_email,
            fieldsValidation,
            'registry_subject.office_email',
          )}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl(
            'new.office_email',
            office_email,
            fieldsValidation,
            'applicant_new.office_email',
          )}
        </Row>
      </>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: false,
            }}
            label="Филиал прекратил деятельность"
          />
        </Col>
      </Row>
      {office_name_change_document && (
        <Row className="row-cols-1">
          {infoFormatterIntl(
            'media.office_name_change_document',
            office_name_change_document ? (
              <FileView
                readOnly
                withoutMime
                withoutHr
                files={[office_name_change_document]}
              />
            ) : null,
            fieldsValidation,
            '',
            6,
          )}
        </Row>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
